module.exports = __webpack_public_path__ + "img/neck.6d765bfd.png";